import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ModalBaseComponent } from 'app/shared/components/base/modal-base/modal-base.component';
import { EmailMessage } from 'app/shared/models/email-message.model';
import { EmailMessageService } from '../../../shared/services/email-message.service';

@Component({
  selector: 'app-send-email-message',
  templateUrl: './send-email-message.component.html',
  styleUrls: ['./send-email-message.component.scss']
})

export class SendEmailMessageComponent extends ModalBaseComponent implements OnInit {

  addedAndSendSuccessfullyMessage: string;

  constructor(public emailMessageService: EmailMessageService, protected activeModal: NgbActiveModal, protected translateService: TranslateService) {
    super(activeModal);
  }

  ngOnInit() {
    this.initializeObject();
  }

  initializeObject() {
    if (this.currentObject == null) {
      this.currentObject = new EmailMessage();
    }
    super.initializeObject();

    this.translateService.get(['sendEmailMessage.addedSuccessfullyMessage', 'sendEmailMessage.addedAndSendSuccessfullyMessage'])
      .subscribe(translations => {
        this.addedSuccessfullyMessage = translations['sendEmailMessage.addedSuccessfullyMessage'];
        this.addedAndSendSuccessfullyMessage = translations['sendEmailMessage.addedAndSendSuccessfullyMessage'];
      });
  }

  onSubmit(form: NgForm) {
    if (!form.value.SmsMessageId) {
      this.emailMessageService.postEmailMessage(form.value, () => this.handleSubmit(form), this.addedSuccessfullyMessage, this.addedAndSendSuccessfullyMessage);
    }
  }
}
